import * as React from 'react';

import {gameGuideComponent, GameGuideComponentPortraitConfigurationContext} from './gameGuideComponentPortraitConfiguration';

const withGameGuidePortraitComponentConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <GameGuideComponentPortraitConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...gameGuideComponent}/>
                );
            }}
        </GameGuideComponentPortraitConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withGameGuidePortraitComponentConfiguration;